import { useState } from '@wordpress/element';
import {
    Popover,
    __experimentalToolsPanel as ToolsPanel,
    __experimentalToolsPanelItem as ToolsPanelItem,
    __experimentalHStack as HStack,
    __experimentalVStack as VStack,
    __experimentalText as Text,
    Button,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const cursorOptions = [
    { name: 'none', className: 'vb-adv-ani-none', icon:'' },
    { name: 'Image 1', className: 'vb-adv-image-auto' , icon:'https://womeninsoccer.org/wp-content/themes/wis/assets/img/splash/cursor/cursor.svg'},
];

export const VayuBlocksCusror = ({ cursorValue, onChange, datakey }) => {

    const animationvalue = cursorValue;

    const [isVisible, setIsVisible] = useState(false);
    const [popoverAnchor, setPopoverAnchor] = useState();

    const toggleVisible = () => setIsVisible((prev) => !prev);

    const handleAnimationClick = (image) => {
        onChange(datakey, {
            ...cursorValue,
            customImage: image
           
        });

        setIsVisible(false);
    };
    
    const resetAll = () => {
        handleAnimationClick('none');
    };

    // Find the matching option based on the icon
    const matchedCursor = cursorOptions.find(option => option.icon === cursorValue.customImage);

    // Fallback if no match is found
    const appliedClass = matchedCursor ? matchedCursor.className : '';

    const appliedName = matchedCursor ? matchedCursor.name : '';

    return (
        <div className="vayu_blocks_animation_panel vb-adv-ani-panel vb-cursor-panel">
            <ToolsPanel
                label={__('Default Cursor')}
                className="vayu_block_animation_name"
                resetAll={resetAll}
            >
                <ToolsPanelItem
                    className="vayu_blocks_animation_toolspanel_item"
                    hasValue={() => !!animationvalue?.customImage}
                    label={__('Default Image', 'vayu-blocks')}
                    onDeselect={() => handleAnimationClick('none')}
                    isShownByDefault
                >
                    <Button
                        ref={setPopoverAnchor}
                        onClick={toggleVisible}
                        className={`block-editor-panel-animation-settings__dropdown ${isVisible ? 'is-open' : ''}`}
                    >
                        <HStack  alignment="left">
                            {animationvalue?.customImage === 'none' || !animationvalue?.customImage ? (
                                <div className="vayu-blocks-panel-ihover vayu-blocks-none-button vayu_blocks_none" />
                            ) : (
                                <div
                                    className={`vayu_blocks_hstack_animation_panel_image vayu_blocks_hstack_animation_panel_image_color ${appliedClass} vb-image-panel-ihover`}
                                > <img src={cursorValue?.customImage} /></div>
                            )}
                            <Text>
                                {__(appliedName || 'Cursor', 'vayu-blocks')}
                            </Text>
                        </HStack>
                    </Button>
                </ToolsPanelItem>
            </ToolsPanel>

            {isVisible && (
                <Popover
                    placement="left-start"
                    className="vayu_blocks_toolspanel_items_popover vb-ani-panel vb-cursor-panel"
                    anchor={popoverAnchor}
                    onClose={() => setIsVisible(false)}
                    offset={35}
                    resize
                >
                    <VStack style={{ padding: '10px', width: '280px' }}>
                        <div>
                            <h4>{__('Deafult Image', 'vayu-blocks')}</h4>
                            <p>{__('Select an Image for your cursor.', 'vayu-blocks')}</p>
                        </div>

                        <HStack justify="flex-start" spacing ={3} wrap={true}>
                            {cursorOptions.map(({ name, className, icon }) => (
                                name === 'none' ? (
                                    <div
                                        key={name}
                                        className={`vayu-blocks-ihover-main-panel ${className} ${animationvalue?.customImage === icon ? 'none-selected' : ''}`}
                                        onClick={() => handleAnimationClick(icon)}
                                        title={name}
                                    >
                                        <div key={name} className="vayu-blocks-panel-ihover vayu-blocks-none-button vayu_blocks_none"/>
                                    </div>
                                ) : (
                                    <div
                                        key={name}
                                        className={`vayu-blocks-ihover-main-panel ${className} ${animationvalue?.customImage === name ? 'selected' : ''}`}
                                        onClick={() => handleAnimationClick(icon)}
                                        title={name}
                                    >
                                        <div className="vayu-blocks-panel-ihover vb-image-panel-ihover">
                                            <img src={icon}></img>
                                        </div>
                                    </div>
                                )
                            ))}
                        </HStack>
                        
                    </VStack>
                </Popover>
            )}
        </div>
    );
};
